import type { BrandPromotionalBanner } from '@/services/innovorder/promotionalBanner/promotionalBanner.type';

import { useBannerAction } from '@/pages/PromotionalBanners/hooks/useBannerAction';

export const useBrandBannerAction = () => useBannerAction<BrandPromotionalBanner>();
